<script src="jobs.component.ts" xmlns="http://www.w3.org/1999/html" xmlns=""></script>
<p-toast position="top-right" [life]="3000" key="tl"></p-toast>

<div>
  <div>
    <div style="margin: 10px">
      <div style="margin-bottom: 10px" [hidden]="!graphicHidden">
        <p-progressBar mode="indeterminate"></p-progressBar>
      </div>
      <div style="display: flex; align-items: baseline">
        <div style="float: left;margin-right: 25px">
          <h4>Select Resource</h4></div>
        <div style="float: right">
          <p-dropdown [options]="resources" [(ngModel)]="resource" placeholder="Select a Resource"
                      (onChange)="onReloadTable(dt)" [style]="{'width':'160px'}"></p-dropdown>
        </div>
      </div>
      <div [hidden]="graphicHidden" style="display: flex; margin-top: 15px">
        <div style="width: 40%" [hidden]="graphicHidden">
          <p-chart type="doughnut" [data]="graphic" [responsive]="true"></p-chart>
        </div>
        <div style="width: 60%" [hidden]="graphicHidden">
          <p-chart type="bar" [data]="bar" [responsive]="true"></p-chart>
        </div>
      </div>
      <div>
        <div style="float: right">
          <button type="button" pButton icon="pi pi-filter-fill" iconPos="left" label="{{filters}}"
                  (click)="onFilterButtonClick()">
          </button>
          <button type="button" pButton icon="fa-file-o" iconPos="left" label="Export to CSV"
                  (click)="dt.exportCSV()">
          </button>
          <button type="button" pButton icon="fa-refresh" iconPos="left" label="Refresh Data"
                  (click)="onReloadTable(dt)">
          </button>
        </div>
        <div>
          <h3>List of Jobs in {{ resource }}
            <i ngClass="fa fa-info-circle" (click)="getArticle('ref.1')" style="cursor: pointer"></i>
          </h3>
          <p-dialog [header]=article.title [(visible)]="displayHelp"  [responsive]="true">
            <div [innerHTML]="article.text | safeHtml">
            </div>
            <p-footer>
              <button type="button" pButton (click)="displayHelp=false" label="Close"></button>
            </p-footer>
          </p-dialog>

          <p-table  #dt [lazy]="false" [columns]="cols" [value]="jobs" [rows]="10"  [rowsPerPageOptions]="[50,100,150]"
                   [paginator]="true" [rowHover]="true"
                   styleClass="text-center" selectionMode="multiple"
                   [(selection)]="selectedJob" dataKey="application" dataKey="location"
                   dataKey="startDate" (onRowSelect)="goDetails($event.data)"
                   [responsive]="true" >
            <ng-template pTemplate="header" let-columns >
              <tr>
                <th *ngFor="let col of columns; let i = index" [ngSwitch]="col.field"[ngStyle]="{'width': col.width}" id="{{i+1}}">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" [hidden]="isFilterApp" [pSortableColumn]="col.field"></p-sortIcon>
                  <p-multiSelect *ngSwitchCase="'appFullName'" [options]="applications" [(ngModel)]="selectedAppFullName" [panelStyle]="{minWidth:'12em'}" [style]="{'width':'100%' }" (onChange)="listLocations();  dt.filter(selectedAppFullName, col.field, 'in' )"
                                 [hidden]="isFilterApp" filter="true"></p-multiSelect>

                  <p-multiSelect *ngSwitchCase="'location'" [options]="locations" [(ngModel)]="selectedLocation"
                                 [style]="{'width':'100%'}" (onChange)="listApplications(); dt.filter(selectedLocation, col.field,'in')"
                                 [hidden]="isFilterApp" filter="true">
                  </p-multiSelect>
                  <input *ngSwitchCase="'jobName'" pInputText type="text" [(ngModel)]="selectedJobName"
                         (input)="dt.filter($event.target.value, col.field, 'contains')"
                         [hidden]="isFilterApp">
                  <input *ngSwitchCase="'description'" pInputText type="text" [(ngModel)]="selectedDescription"
                         (input)="dt.filter($event.target.value, col.field, 'contains')"
                         [hidden]="isFilterApp">

                  <p-multiSelect *ngSwitchCase="'status'" [options]="statusOptions" [(ngModel)]="selectedStatus"
                              [style]="{'width':'100%'}" id="rembold" showToggleAll="false"  (onChange)=" dt.filter(selectedStatus, col.field, 'in')"
                              [hidden]="isFilterApp" styleClass="multi">
                  </p-multiSelect>
                  <div>
                    <p-calendar [utc]="true"
                                *ngSwitchCase="'startDate'" [(ngModel)]="selectedStartDate"
                                dateFormat="dd/mm/yy"
                                [showButtonBar]="true"
                                (onSelect)="dt.filter(convertDate($event.getTime()), col.field, 'equals')"
                                (onClearClick)="dt.filter(null, col.field, 'contains')"
                                [hidden]="isFilterApp">
                    </p-calendar>
                  </div>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr [pSelectableRow]="rowData">
                <td *ngFor="let col of columns" [title]="rowData['description']">
                  <span *ngIf="col.field === 'startDate'"> {{rowData['jobDate'] | date:'dd/MM/yyyy'}}</span>
                  <span *ngIf="col.field === 'percentage'">
                    <div [style.background]="checkDeviation(rowData['percentage']) ? 'indianred' : null"
                         [style.color]="checkDeviation(rowData['percentage']) ? 'white' : null"
                         [title]="rowData['description']">
                          {{calculateDeviation(rowData['status'], rowData['runTime'],
                          rowData['averageTime'], rowData['percentage'])}}
                  </div>
                  </span>
                  <span *ngIf="col.field === 'status'">
                  <div [style.color]="statusHandler(rowData[col.field])">
                    {{rowData[col.field]}}
                    <i [ngClass]="statusIconHandler(rowData[col.field])"></i>
                  </div>
                  </span>
                  <span
                    *ngIf="col.field === 'startTime'"> {{!rowData['startTime'] ?  '--' : rowData['startTime']}}</span>
                  <span *ngIf="col.field !== 'startDate' && col.field !== 'status'
                              && col.field !== 'startTime'
                              && col.field !== 'percentage'"> {{rowData[col.field]}}</span>
                </td>
              </tr>
            </ng-template>
          </p-table>

        </div>
      </div>
    </div>
  </div>
</div>

